(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrblue-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
var panel=document.querySelector('[data-mbcd]');
var overlay=document.querySelector('[data-mbcd-overlay]');
if(!panel)return;
var TH=(parseInt(panel.getAttribute('data-mbcd-th'),10)||39)*100;
function money(c){try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(c/100);}catch(e){return (c/100).toFixed(2)+' EUR';}}
function openD(){panel.classList.add('open');overlay.classList.add('open');document.documentElement.style.overflow='hidden';}
function closeD(){panel.classList.remove('open');overlay.classList.remove('open');document.documentElement.style.overflow='';}
function render(cart){
  document.querySelectorAll('[data-mbcd-count]').forEach(function(el){el.textContent=cart.item_count;});
  document.querySelectorAll('[data-mb-count]').forEach(function(el){if(el.textContent!==String(cart.item_count))el.textContent=cart.item_count;});
  document.querySelector('[data-mbcd-subtotal]').textContent=money(cart.total_price);
  var msg=document.querySelector('[data-mbcd-shipmsg]');
  var fill=document.querySelector('[data-mbcd-shipfill]');
  var rem=TH-cart.total_price;
  if(rem>0){msg.innerHTML='Noch <span style="color:var(--blue)">'+money(rem)+'</span> bis zur kostenlosen Lieferung innerhalb Deutschlands';fill.classList.remove('full');}
  else{msg.innerHTML='<span class="ok">✓ Kostenlose Lieferung innerhalb Deutschlands freigeschaltet</span>';fill.classList.add('full');}
  fill.style.width=Math.min(100,cart.total_price/TH*100)+'%';
  var box=document.querySelector('[data-mbcd-items]');
  if(cart.items.length===0){box.innerHTML='<div class="mbcd-empty">Dein Warenkorb ist leer.</div>';return;}
  var html='';
  cart.items.forEach(function(it,i){
    html+='<div class="mbcd-item">';
    html+='<a class="mbcd-item-img" href="'+it.url+'">'+(it.image?'<img src="'+it.image+'" alt="">':'')+'</a>';
    html+='<div class="mbcd-item-info">';
    html+='<a class="mbcd-item-title" href="'+it.url+'">'+it.product_title+'</a>';
    if(it.variant_title&&it.variant_title!=='Default Title'){html+='<div class="mbcd-item-var">'+it.variant_title+'</div>';}
    html+='<div class="mbcd-item-row">';
    html+='<div class="mbcd-qty"><button type="button" data-mbcd-line="'+(i+1)+'" data-mbcd-d="-1">−</button><span>'+it.quantity+'</span><button type="button" data-mbcd-line="'+(i+1)+'" data-mbcd-d="1">+</button></div>';
    html+='<div class="mbcd-item-price">'+money(it.final_line_price)+'</div>';
    html+='</div></div></div>';
  });
  box.innerHTML=html;
  box.querySelectorAll('[data-mbcd-line]').forEach(function(b){
    b.addEventListener('click',function(){
      var line=parseInt(b.getAttribute('data-mbcd-line'),10);
      var d=parseInt(b.getAttribute('data-mbcd-d'),10);
      var qty=parseInt(b.parentElement.querySelector('span').textContent,10)+d;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,qty)})})
      .then(function(r){return r.json();}).then(render);
    });
  });
}
function refresh(cb){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){render(c);if(cb)cb(c);});}
document.querySelectorAll('[data-mb-cartlink]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();refresh();openD();});});
document.querySelector('[data-mbcd-close]').addEventListener('click',closeD);
overlay.addEventListener('click',closeD);
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeD();});
panel.querySelectorAll('[data-mbcd-upadd]').forEach(function(btn){
  btn.addEventListener('click',function(){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(btn.getAttribute('data-mbcd-upadd'),10),quantity:1})})
    .then(function(r){return r.json();}).then(function(){refresh();});
  });
});
document.addEventListener('mb:cart:added',function(){refresh();openD();});
var headCount=document.querySelector('.mb-header [data-mb-count]');
if(headCount){
  var last=headCount.textContent;
  new MutationObserver(function(){
    if(headCount.textContent!==last){last=headCount.textContent;refresh();openD();}
  }).observe(headCount,{childList:true,characterData:true,subtree:true});
}
refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrblue-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
var sortSel=document.querySelector('[data-mb-sort]');
if(sortSel){sortSel.addEventListener('change',function(){var u=new URL(window.location.href);u.searchParams.set('sort_by',sortSel.value);u.searchParams.delete('page');window.location.href=u.toString();});}
var dt=document.querySelector('[data-mb-desc-toggle]');
if(dt){dt.addEventListener('click',function(){
  var s=document.querySelector('[data-mb-desc-short]');var f=document.querySelector('[data-mb-desc-full]');
  var open=f.hidden;f.hidden=!open;s.hidden=open;
  dt.textContent=open?'Weniger anzeigen':'Mehr anzeigen';dt.setAttribute('aria-expanded',open?'true':'false');
});}
var form=document.querySelector('[data-mb-filterform]');
if(form){
  form.addEventListener('change',function(e){
    if(e.target && e.target.type==='checkbox'){form.submit();}
  });
  form.addEventListener('submit',function(){
    Array.prototype.forEach.call(form.querySelectorAll('input'),function(i){
      if(i.type!=='hidden' && i.value===''){i.disabled=true;}
    });
  });
}
var ftoggle=document.querySelector('[data-mb-ftoggle]');
if(ftoggle && form){
  ftoggle.addEventListener('click',function(){
    var open=form.classList.toggle('is-open');
    ftoggle.setAttribute('aria-expanded',open?'true':'false');
  });
}
document.addEventListener('click',function(e){
  Array.prototype.forEach.call(document.querySelectorAll('.mb-filter[open]'),function(d){
    if(!d.contains(e.target)){d.removeAttribute('open');}
  });
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrblue-header"] && !Shopify.designMode) return;
  try {
    
(function(){
var drawer=document.getElementById('mb-drawer');
var backdrop=document.querySelector('.mb-drawer-backdrop');
var opener=document.querySelector('[data-mb-drawer-open]');
if(!drawer||!opener)return;
var lastFocus=null;
function open(){
  lastFocus=document.activeElement;
  drawer.hidden=false;backdrop.hidden=false;
  requestAnimationFrame(function(){drawer.classList.add('is-open');backdrop.classList.add('is-open');});
  document.documentElement.classList.add('mb-drawer-lock');
  opener.setAttribute('aria-expanded','true');
  var f=drawer.querySelector('.mb-drawer-x');if(f)f.focus();
}
function close(){
  drawer.classList.remove('is-open');backdrop.classList.remove('is-open');
  document.documentElement.classList.remove('mb-drawer-lock');
  opener.setAttribute('aria-expanded','false');
  setTimeout(function(){drawer.hidden=true;backdrop.hidden=true;},280);
  if(lastFocus&&lastFocus.focus)lastFocus.focus();
}
opener.addEventListener('click',open);
document.querySelectorAll('[data-mb-drawer-close]').forEach(function(b){b.addEventListener('click',close);});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('is-open'))close();});
var mq=window.matchMedia('(min-width:861px)');
function onMq(){if(mq.matches&&drawer.classList.contains('is-open'))close();}
if(mq.addEventListener){mq.addEventListener('change',onMq);}
/* nur ein Untermenü gleichzeitig offen */
drawer.querySelectorAll('details').forEach(function(d){
  d.addEventListener('toggle',function(){if(d.open){drawer.querySelectorAll('details[open]').forEach(function(o){if(o!==d)o.open=false;});}});
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrblue-product"] && !Shopify.designMode) return;
  try {
    
(function(){
var dataEl=document.querySelector('[data-mb-vdata]');
if(!dataEl)return;
var data=JSON.parse(dataEl.textContent);
var atc=document.querySelector('[data-mb-atc]');
var buyrow=document.querySelector('[data-mb-buyrow]');
var notify=document.querySelector('[data-mb-notify]');
var notifyVar=document.querySelector('[data-mb-notify-variant]');
var sel={};
var curMax=9999, curPre=false;
document.querySelectorAll('.copt.sel,.lopt.sel').forEach(function(el){sel[el.getAttribute('data-mb-pos')]=el.getAttribute('data-mb-val');});
function find(){
  for(var i=0;i<data.length;i++){var v=data[i];var ok=true;
    for(var p in sel){if(sel[p]!==null&&v['o'+p]!==sel[p]){ok=false;break;}}
    if(ok)return v;}
  return null;}
function applyMax(){
  var s=document.querySelector('[data-mb-qty]');var plus=document.querySelector('[data-mb-q="1"]');var note=document.querySelector('[data-mb-qtymax]');
  if(!s)return;
  var q=parseInt(s.textContent,10);
  if(curMax<1)curMax=1;
  if(q>curMax){q=curMax;s.textContent=q;}
  var atMax=q>=curMax;
  if(plus)plus.disabled=atMax;
  if(note)note.hidden=!(atMax&&curMax<9999);
}
function setState(v){
  var line=document.querySelector('.stockline');var st=document.querySelector('[data-mb-stocktext]');var dot=document.querySelector('[data-mb-dot]');
  var sold=!v||!v.available;
  curPre=!!(v&&v.pre);
  if(buyrow)buyrow.hidden=sold;
  if(notify)notify.hidden=!sold;
  if(notifyVar&&v)notifyVar.value=v.title;
  if(!v){st.textContent='Kombination nicht verfügbar';st.style.color='var(--red)';dot.style.background='var(--red)';return;}
  if(sold){st.textContent='Ausverkauft';st.style.color='var(--red)';dot.style.background='var(--red)';return;}
  if(curPre){st.textContent=line.getAttribute('data-mb-pretext');st.style.color='var(--blue)';dot.style.background='var(--blue)';atc.textContent=atc.getAttribute('data-mb-prelabel');}
  else{st.textContent=line.getAttribute('data-mb-instock');st.style.color='';dot.style.background='';atc.textContent=atc.getAttribute('data-mb-label');}
}
function update(){var v=find();
  if(v){
    document.querySelector('[data-mb-price]').textContent=v.price;
    atc.setAttribute('data-mb-vid',v.id);
    curMax=(typeof v.max==='number')?v.max:9999;
    applyMax();
    for(var p in sel){var dd=document.querySelector('[data-mb-spec="'+p+'"]');if(dd&&sel[p])dd.textContent=sel[p];}
  }
  setState(v);
}
document.querySelectorAll('.copt').forEach(function(b){b.addEventListener('click',function(){
  var pos=b.getAttribute('data-mb-pos');
  document.querySelectorAll('.copt[data-mb-pos="'+pos+'"]').forEach(function(c){c.classList.remove('sel');});
  b.classList.add('sel');sel[pos]=b.getAttribute('data-mb-val');update();});});
document.querySelectorAll('.lopt').forEach(function(b){b.addEventListener('click',function(){
  var pos=b.getAttribute('data-mb-pos');
  document.querySelectorAll('.lopt[data-mb-pos="'+pos+'"]').forEach(function(c){c.classList.remove('sel');});
  b.classList.add('sel');sel[pos]=b.getAttribute('data-mb-val');update();});});
document.querySelectorAll('[data-mb-q]').forEach(function(b){b.addEventListener('click',function(){var s=document.querySelector('[data-mb-qty]');var n=parseInt(s.textContent,10)+parseInt(b.getAttribute('data-mb-q'),10);n=Math.max(1,Math.min(curMax,n));s.textContent=n;applyMax();});});
document.querySelectorAll('[data-mb-thumb]').forEach(function(b){b.addEventListener('click',function(){var m=document.getElementById('mb-gal-main');if(m){m.src=b.getAttribute('data-mb-thumb');}document.querySelectorAll('.gal-thumbs button').forEach(function(t){t.classList.remove('active');});b.classList.add('active');});});
if(atc){atc.addEventListener('click',function(){
  var id=parseInt(atc.getAttribute('data-mb-vid'),10);
  var qty=parseInt(document.querySelector('[data-mb-qty]').textContent,10);
  var item={id:id,quantity:qty};
  if(curPre){item.properties={'Vorbestellung':'Ja'};}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(item)})
  .then(function(r){return r.json();})
  .then(function(){
    atc.textContent='✓ Im Warenkorb';
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('[data-mb-count]').forEach(function(el){el.textContent=c.item_count;});});
    setTimeout(function(){atc.textContent=curPre?atc.getAttribute('data-mb-prelabel'):atc.getAttribute('data-mb-label');},1200);
  });
});}
/* Startzustand */
(function(){var v=find();if(v){curMax=(typeof v.max==='number')?v.max:9999;curPre=!!v.pre;applyMax();}})();
/* Nach Absenden des Formulars zum Formular scrollen */
if(/contact_posted=true/.test(location.search)&&notify){notify.hidden=false;notify.scrollIntoView({block:'center'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrblue-spotlight"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mb-banner [data-mb-add]').forEach(function(btn){
  if(btn.dataset.mbBound)return;btn.dataset.mbBound='1';
  btn.addEventListener('click',function(){
    var id=parseInt(btn.getAttribute('data-mb-add'),10);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
    .then(function(r){return r.json();})
    .then(function(){
      btn.textContent='✓ Im Warenkorb';
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('[data-mb-count]').forEach(function(el){el.textContent=c.item_count;});});
      setTimeout(function(){btn.textContent=btn.getAttribute('data-mb-label');},1200);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrblue-topbar"] && !Shopify.designMode) return;
  try {
    
(function(){
document.querySelectorAll('[data-mb-ann]').forEach(function(bar){
  var items=bar.querySelectorAll('.mb-ann-item');
  if(!items.length)return;
  var i=0;items[0].classList.add('is-active');bar.classList.add('is-ready');
  if(items.length<2)return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var ms=Math.max(2,parseFloat(bar.getAttribute('data-interval'))||5)*1000;
  var paused=false,timer=null;
  function next(){if(paused)return;items[i].classList.remove('is-active');i=(i+1)%items.length;items[i].classList.add('is-active');}
  function start(){stop();timer=setInterval(next,ms);}
  function stop(){if(timer){clearInterval(timer);timer=null;}}
  bar.addEventListener('mouseenter',function(){paused=true;});
  bar.addEventListener('mouseleave',function(){paused=false;});
  bar.addEventListener('focusin',function(){paused=true;});
  bar.addEventListener('focusout',function(){paused=false;});
  bar.addEventListener('touchstart',function(){paused=!paused;},{passive:true});
  document.addEventListener('visibilitychange',function(){if(document.hidden){stop();}else{start();}});
  start();
});
})();

  } catch(e) { console.error(e); }
})();
})();
